import { tncResponse, useGetTnc } from "@/app/api"
import { RootState } from "@/app/store"
import sanitizeHtml from "sanitize-html"

export default function Tnc() {
  const t = useTranslate()
  const lang = useAppSelector((state: RootState) => state.app.lang)
  const getTnc = useGetTnc()

  const [tncResponse, setTncResponse] = useState<tncResponse | null>(null)

  useEffect(() => {
    ;(async () => {
      const res = await getTnc(lang)
      setTncResponse(res)
    })()
  }, [lang])

  return (
    tncResponse && (
      <>
        <div className="body">
          <div className="receipt">
            <p className="text1 text-left">{t("tnc.title")}</p>
            <p
              className="text2 text-left whitespace-pre-line"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(tncResponse.tnc),
              }}
            ></p>
          </div>
        </div>
      </>
    )
  )
}
